<template>
  <div>
    <div class="va-row">
      <div class="flex md12 xs12">
        <vuestic-data-table
          class="text-center"
          :apiMode="true"
          :apiUrl="apiUrl"
          :httpOptions="httpOptions"
          :defaultPerPage="defaultTablePerPage"
          :tableFields="tableFields"
          :reloadTable="reloadTable"
          :perPageSelectorShown="false"
          :actions="true"
          :additionalActions="true"
          :filterInputShown="false"
          :actionsWide="true"
        >
          <template slot="additionalTableControl">
            <div class="form-group">
              <button
                class="btn btn-micro btn-success"
                :class="!activeFilter ? 'active' : ''"
                @click="setGroupBy('')"
              >
                Summary
              </button>
              <button
                class="btn btn-micro btn-success mx-1"
                :class="activeFilter === 'day' ? 'active' : ''"
                @click="setGroupBy('day')"
              >
                By Days
              </button>
              <button
                class="btn btn-micro btn-success"
                :class="activeFilter === 'month' ? 'active' : ''"
                @click="setGroupBy('month')"
              >
                By Months
              </button>
            </div>
            <vuestic-multi-select
              label="Show by"
              v-model="groupBySelected"
              :options="groupByList"
              :optionKey="'title'"
              :name="'group_by'"
            />
            <div class="form-group">
              <div class="input-group">
                <vuestic-date-picker
                  id="simple-input-2"
                  v-model="range"
                  :config="{ mode: 'range' }"
                />
                <label class="control-label" for="simple-input-2"
                  >Select Period</label
                >
                <i class="bar"></i>
              </div>
            </div>
          </template>
        </vuestic-data-table>
      </div>
    </div>
  </div>
</template>

<script>
import VuesticDatePicker from '../../vuestic-theme/vuestic-components/vuestic-date-picker/VuesticDatePicker.vue'
import { mapGetters } from 'vuex'
const moment = require('moment')
export default {
  components: {
    VuesticDatePicker
  },
  data() {
    return {
      reloadTable: false,
      range: null,
      dateTo: new Date().toJSON().slice(0, 10),
      dateFrom: moment(this.dateTo)
        .subtract('3', 'months')
        .format('YYYY-MM-DD'),
      groupBySelected: [],
      groupByList: [
        { title: 'Service Name', value: 'codeName' },
        { title: 'Package', value: 'packageName' },
        { title: 'Account', value: 'accountsName' }
      ],
      groupBy: '',
      additionalGroupBy: '',
      activeFilter: null,
      httpOptions: {
        headers: { Authorization: 'Bearer ' + localStorage.getItem('cTok') }
      },
      defaultTablePerPage: 10
    }
  },
  watch: {
    range: {
      immediate: true,
      handler(val) {
        this.dateFrom = moment(this.dateTo)
          .subtract('89', 'days')
          .format('YYYY-MM-DD')
        if (val && val.indexOf('to') !== -1) {
          this.dateFrom = val.split(' to ')[0]
          this.dateTo = val.split(' to ')[1]
          let diff = moment(this.dateTo).diff(moment(this.dateFrom), 'days')
          if (diff > 89) {
            this.dateFrom = moment(this.dateTo)
              .subtract('89', 'days')
              .format('YYYY-MM-DD')
            this.range = `${this.dateFrom} to ${this.dateTo}`
          }
        }
      }
    },
    tableFields() {
      this.refreshTable()
    },
    groupBySelected(val) {
      let values = val.map(el => el.value)
      this.groupBy = values.join(',')
    }
  },
  computed: {
    ...mapGetters(['tenantID']),
    apiUrl() {
      return `${process.env.VUE_APP_WEBSITE_URL}billing/api/v1/summary/?tenant_uuid=${this.tenantID}&dateFrom=${this.dateFrom}&dateTo=${this.dateTo}&groupBy=${this.groupBy},${this.additionalGroupBy}`
    },
    tableFields() {
      let fields = []
      const sequence = {
        name: '__sequence',
        dataClass: 'text-light'
      }
      const constantFields = [
        {
          name: 'serviceName',
          title: 'Service Type'
        },
        {
          name: 'amount',
          title: 'Volume'
        },
        {
          name: 'quantity',
          title: 'Quantity'
        },
        {
          name: 'cost',
          title: 'Cost'
        },
        {
          name: 'currency',
          title: 'Currency'
        }
      ]
      let extraFields = []

      if (this.groupBy.indexOf('codeName') !== -1) {
        extraFields.push({
          name: 'codeName',
          title: 'Service Name'
        })
      }
      if (this.groupBy.indexOf('packageName') !== -1) {
        extraFields.push({
          name: 'packageName',
          title: 'Package'
        })
      }
      if (this.groupBy.indexOf('accountsName') !== -1) {
        extraFields.push({
          name: 'accountsName',
          title: 'Account'
        })
      }
      if (this.additionalGroupBy == '') {
        fields = [sequence, ...extraFields, ...constantFields]
      } else if (this.additionalGroupBy == 'day') {
        fields = [
          sequence,
          {
            name: 'day',
            title: 'Day'
          },
          ...extraFields,
          ...constantFields
        ]
      } else {
        fields = [
          sequence,
          {
            name: 'month',
            title: 'Month'
          },
          ...extraFields,
          ...constantFields
        ]
      }
      return fields
    }
  },
  methods: {
    setGroupBy(val) {
      if (this.additionalGroupBy != val) {
        this.additionalGroupBy = val
        this.activeFilter = val
      }
    },
    refreshTable() {
      this.reloadTable = false
      setTimeout(() => {
        this.reloadTable = true
      }, 0)
    }
  }
}
</script>
<style lang="scss" scoped>
.form-group {
  min-width: 18rem;
}
</style>
